import { Boxes } from 'lucide-react'
import { Link } from '@tanstack/react-router'

import type { HomeWidgetDefinition } from '@/lib/home-widgets'
import { AGENT_PERMISSIONS } from '@/lib/permissions'

import { AssetsSummaryWidget } from './features/asset-list/assets-summary-widget'

export const assetHomeWidgets = [{
  id: 'assets.summary', name: 'Assets', description: 'Assets observed in the selected entity.',
  icon: Boxes, order: 40,
  defaultSize: { columns: 1, rows: 4 }, minimumSize: { columns: 1, rows: 3 },
  permission: AGENT_PERMISSIONS.read,
  viewAll: ({ entityId, className }) => <Link to="/$entityId/assets" params={{ entityId }} className={className}>View assets</Link>,
  component: AssetsSummaryWidget,
}] satisfies readonly HomeWidgetDefinition[]
